import React, { useEffect, useState } from 'react'
import "./styles/DownloadFormatsBtn.scss";
import { downloadFormatsQuery } from './query';
import { Query } from 'react-apollo';
import { unzipFile } from './utils';
import LinksDownloadFormats from './components/LinksDownloadFormats';
import LoadingMessage from 'utils/components/LoadingMessage';
import { FormattedMessage } from 'react-intl';

const DownloadFormatsContainer = () => {
  const [authorizationFormats, setAuthorizationFormats] = useState({
    zipUrl: null,
    extractedFiles: [],
  });
  
  useEffect(() => {
    const processFormats = async () => {
      try {
        if (!authorizationFormats.zipUrl) return;

        const extractedFormats = await unzipFile(authorizationFormats?.zipUrl);
        setAuthorizationFormats((prev) => ({ ...prev, extractedFiles: extractedFormats }));
      } catch (error) {
        console.error('Error processing formats:', error);
      }
    }

    processFormats();
  }, [authorizationFormats.zipUrl])

  return (
    <div className='download-formats--btn d-inline-block col-12 px-0'>
      <Query
        query={downloadFormatsQuery}
        onCompleted={(data) => {
          if (data?.downloadFormats?.url && !authorizationFormats.zipUrl) {
            setAuthorizationFormats((prev) => ({ ...prev, zipUrl: data.downloadFormats.url }));
          }
        }}
      >
        {({ loading, error }) => {
          return (
            <>
              <p className="links-download-formats__text mb-0 font-weight-bold text-center">
                <FormattedMessage
                  id="ProjectStepFormDisclaimer.downloadFormats"
                  defaultMessage="En caso contrario, descarga aquí el formato de autorización:"
                />
              </p>
              <LinksDownloadFormats
                loadingFormats={loading}
                authorizationFormats={authorizationFormats}
              />
            </>
          )
        }}
      </Query>
    </div>
  );
}

export default DownloadFormatsContainer